import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managerolepermission',
  templateUrl: './managerolepermission.component.html',
  styleUrls: ['./managerolepermission.component.css']
})
export class ManagerolepermissionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
